import { IAnalyticSdr } from '../../../types/analyticsSdr';

/**
 * Analytics SDR for Users Domain.
 * This information should match the values in the SDR Excel file referenced here:
 * https://chalk.charter.com/display/ERSPM/FE+Analytics
 */

const siteSection = 'Users';

export const usersAnalytics: IAnalyticSdr = {
  usersAnalytic: {
    siteSection,
    buttonClicks: {
      addNewUserBtn: {
        itemClicked: 'Add New User',
      },
      filterCancelBtn: {
        itemClicked: 'Cancel',
      },
      filterViewResultsBtn: {
        itemClicked: 'View Results',
      },
      filterClearFiltersBtn: {
        itemClicked: 'Clear Filters',
      },
      filterCloseDrawerBtn: {
        itemClicked: 'Close',
      },
      sendRegistrationEmailBtn: {
        itemClicked: 'Send Registration Email',
      },
      sendRegLinkModalSendLinksBtn: {
        itemClicked: 'Send Links',
      },
      sendRegLinkModalCancelBtn: {
        itemClicked: 'Cancel',
      },
      sendRegLinkModalCloseBtn: {
        itemClicked: 'Close',
      },
    },
    menuSelections: {
      organizationsMenu: {
        itemClicked: 'Organizations',
      },
      accessPoliciesMenu: {
        itemClicked: 'Access Policies',
      },
    },
  },

  userCreate: {
    siteSection,
    siteSubSection: 'Create User',
    buttonClicks: {
      createBackBtn: {
        itemClicked: 'Back',
      },
      createCancelBtn: {
        itemClicked: 'Cancel',
      },
      createSaveBtn: {
        itemClicked: 'Save',
      },
      createSaveBtnValidationErr: {
        itemClicked: 'Save - Validation Error',
      },
      createSaveBtnServerErr: {
        itemClicked: 'Save - Server Error',
      },
      internalUserRadioBtn: {
        itemClicked: 'Internal',
      },
      externalUserRadioBtn: {
        itemClicked: 'External',
      },
    },
    menuSelections: {
      organizationsMenu: {
        itemClicked: 'Organizations',
      },
      registrationLinkCheckBox: {
        itemClicked: 'Send registration link to this email address',
      },
    },
  },

  userEdit: {
    siteSection,
    siteSubSection: 'Edit User',
  },

  userSummary: {
    siteSection,
    siteSubSection: 'View User Summary',
  },

  userSuccess: {
    siteSection,
    siteSubSection: 'Create Or Edit User',
    siteSubSubSection: 'Success',
  },

  userViewPage: {
    siteSection,
    siteSubSection: 'User View Page',
    buttonClicks: {
      backToUsersBtn: {
        itemClicked: 'Back to Users',
      },
      viewAsUserBtn: {
        itemClicked: 'View as User',
      },
      requestUpdateLink: {
        itemClicked: 'Request an Update',
      },
      overviewTab: {
        itemClicked: 'Overview',
      },
      notificationSettingsTab: {
        itemClicked: 'Notification Settings',
      },
      editAccountDetailsBtn: {
        itemClicked: 'Edit account Details',
      },
      editAccountDetailsMenuBtn: {
        itemClicked: 'Edit Account Details',
      },
      deleteUserMenuBtn: {
        itemClicked: 'Delete User',
      },
      editAccessPoliciesBtn: {
        itemClicked: 'Edit Access Policies',
      },
      orgLink: {
        itemClicked: 'Organization link',
      },
      sendNewRegLink: {
        itemClicked: 'Send New Registration Email',
      },
      deleteUserModalDeleteBtn: {
        itemClicked: 'Delete',
      },
      deleteUserModalCancelBtn: {
        itemClicked: 'Cancel',
      },
      deleteUserModalCloseBtn: {
        itemClicked: 'Close',
      },
      editUnverifiedUserModalCloseBtn: {
        itemClicked: 'Close',
      },
      moreOptions: {
        itemClicked: 'More Options',
      },
      changeToAdminMenuBtn: {
        itemClicked: 'Change to Admin Access',
      },
      changeToLimitedAccessMenuBtn: {
        itemClicked: 'Change to Limited Access',
      },
      reassignSuperAdminMenuBtn: {
        itemClicked: 'Reassign Super Admin',
      },
    },
  },

  userEditDetails: {
    siteSection,
    siteSubSection: 'Edit Account Details',
    buttonClicks: {
      editBackBtn: {
        itemClicked: 'Back to user',
      },
      editSaveBtn: {
        itemClicked: 'Save',
      },
      editSaveBtnValidationErr: {
        itemClicked: 'Save - Validation Error',
      },
      editCancelBtn: {
        itemClicked: 'Cancel',
      },
      removeOrganizationChip: {
        itemClicked: 'Remove Organization Chip',
      },
    },
    menuSelections: {
      assignOrgMenu: {
        itemClicked: 'Assign to Organization',
      },
    },
  },
  userEditPolicies: {
    siteSection,
    siteSubSection: 'Edit Access Policies',
    buttonClicks: {
      backBtn: {
        itemClicked: 'Back to User',
      },
      requestUpdateLink: {
        itemClicked: 'Request an Update',
      },
      saveBtn: {
        itemClicked: 'Save',
      },
      cancelBtn: {
        itemClicked: 'Cancel',
      },
    },
  },

  userInviteStatus: {
    siteSection,
    siteSubSection: 'Invitation Status',
  },

  userVdsChange: {
    siteSection,
    siteSubSection: 'Virtual Directory Service',
    buttonClicks: {
      vdsTurnOnBtn: {
        itemClicked: 'Turn On',
      },
      vdsTurnOffBtn: {
        itemClicked: 'Turn Off',
      },
      vdsCancelBtn: {
        itemClicked: 'Cancel',
      },
      vdsTryAgainBtn: {
        itemClicked: 'Try Again',
      },
    },
    menuSelections: {
      vdsToggleMenu: {
        itemClicked: 'VDS Toggle',
      },
    },
  },
};
